import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import usePresentSelector from './usePresentSelector';
import A from './ActionCreators';
import G from './Getters';
import {
  Button,
  Menu,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box
} from "@material-ui/core";

export default function CredentialMenuDemo() {
  const dispatch = useDispatch();


  const { username, errorMessage } = usePresentSelector(state => ({
    username: state.loginInfo.username,
    errorMessage: G.getAuthResponseMessage(state)
  }));


  const [anchorEl, setAnchorEl] = useState(null);
  const [creds, setCreds] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [tempCreds, setTempCreds] = useState({ email: "", password: "" });

  const loggedIn = !!username;

  useEffect(() => {
    const stored = localStorage.getItem("defaultCreds");
    if (stored) setCreds(JSON.parse(stored));
  }, []);

  const saveCreds = () => {
    localStorage.setItem("defaultCreds", JSON.stringify(tempCreds));
    setCreds(tempCreds);
    setOpenDialog(false);
  };

  const handleLogin = () => {
    if (!loggedIn) {

    if (creds) {

      dispatch(A.tryLogin(creds));
    } else {
      setOpenDialog(true);
    }
    }else{
      dispatch(A.tryLogout({force:true}));
    }
  }

  return (
    <div style={{ display: "inline-block" }}>
      <Button
        size="small"
        color="inherit"
        onClick={handleLogin}
        onContextMenu={(e) => {
          e.preventDefault();
          setAnchorEl(e.currentTarget);
        }}
        style={{ textTransform: "none" }}
      >
        {loggedIn
          ? `Logout (${username || "user"})`
          : creds
          ? `Login as ${creds.email}`
          : `Set Credentials`}
      </Button>
        {!loggedIn && errorMessage && (
        <Typography
          color="error"
          variant="caption"
          style={{ display: 'block', marginTop: 4 }}
        >
          {errorMessage}
        </Typography>
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            setTempCreds(creds || { email: "", password: "" });
            setOpenDialog(true);
            setAnchorEl(null);
          }}
        >
          Change Credentials
        </MenuItem>
        <MenuItem
          onClick={() => {
            localStorage.removeItem("defaultCreds");
            setCreds(null);
            setAnchorEl(null);
          }}
        >
          Clear Stored Credentials
        </MenuItem>
      </Menu>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Set Default Credentials</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Email"
            value={tempCreds.email}
            onChange={(e) => setTempCreds({ ...tempCreds, email: e.target.value })}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Password"
            //type="password"
            value={tempCreds.password}
            onChange={(e) => setTempCreds({ ...tempCreds, password: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button color="primary" onClick={saveCreds}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

  ;
}
/*


//import React, { useState, useEffect } from "react";
import {
  Button,
  Menu,
  MenuItem,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box
} from "@material-ui/core";

export default function CredentialMenuDemo() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [creds, setCreds] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [tempCreds, setTempCreds] = useState({ username: "", password: "" });
  const [username, setUsername] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("defaultCreds");
    if (stored) setCreds(JSON.parse(stored));
  }, []);

  const saveCreds = () => {
    localStorage.setItem("defaultCreds", JSON.stringify(tempCreds));
    setCreds(tempCreds);
    setOpenDialog(false);
  };

  const handleLogin = () => {
    if (username) {
      setUsername(null);
    } else if (creds) {
      setUsername(creds.username);
    } else {
      setOpenDialog(true);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      gap={2}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={handleLogin}
        onContextMenu={(e

/*
export default function Main(){
  //click button to sign in with a local account
  //(not with google)
  let dispatch = useDispatch();
  let username = usePresentSelector(state => state.loginInfo.username);


  let creds = {

  }


  let text = username?"(dev) Logout":"(pi@pi) Login";

  return (
    <div onClick={() => {
      if(username){
        dispatch(A.tryLogout());
      }else{

        dispatch(A.tryLogout({
          force:true
        }))


        
      }
    }}
      class="top-navbar-item hoverable">
      {text}
    </div>
  )
  */

